import SelectedEventTypeForm from './SelectedEventTypeForm';

export default SelectedEventTypeForm;
